import React, { useState } from 'react';

import { DownOutlined } from '@ant-design/icons';
import {
  Button as AntdButton,
  Dropdown as AntdDropdown,
  Menu as AntdMenu,
} from 'antd';

import {
  CentreVHUDto,
  ConditionsReactivateCentreVHUDto,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';

import ModalDesactivation from '../Modals/ModalDesactivation/ModalDesactivation';
import ModalReactivation from '../Modals/ModalReactivation/ModalReactivation';

import ConditionReactivateCentreVHU from './ConditionReactivateCentreVHU/ConditionReactivateCentreVHU';
import ModalDetails from './Modals/ModalDetails';
import ModalUpdate from './Modals/ModalUpdate';
import { useChangeValidityCentreVHU } from './utils';

import './CellDetailsAndActions.less';

interface CellDetailsAndActionsProps {
  centreVHU: CentreVHUDto;
  refreshDashboard: () => void;
}

function CellDetailsAndActions({
  centreVHU,
  refreshDashboard,
}: CellDetailsAndActionsProps): React.ReactElement {
  const [isDetailsOpen, setIsDetailsOpen] = useState<boolean>(false);
  const [isUpdateOpen, setIsUpdateOpen] = useState<boolean>(false);
  const [isChangeValidityOpen, setIsChangeValidityOpen] =
    useState<boolean>(false);

  const controller = useApi().AdminFonctionnelControllerApi;

  const [
    submitReactivateReferentiel,
    submitDeprecateReferentiel,
    conditionsReactivateReferentiel,
    getUsesRequest,
  ] = useChangeValidityCentreVHU(controller);

  const conditionUnlock = (
    conditions: ConditionsReactivateCentreVHUDto | undefined,
  ): boolean => {
    return conditions?.reactivationAvailable ?? false;
  };

  const closeUpdateValidity = () => {
    setIsChangeValidityOpen(false);
  };

  const menu = (
    <AntdMenu>
      <AntdMenu.Item
        onClick={() => {
          setIsUpdateOpen(true);
        }}
      >
        Modifier
      </AntdMenu.Item>
      <AntdMenu.Item
        onClick={() => {
          setIsChangeValidityOpen(true);
        }}
      >
        {centreVHU.valid
          ? 'Désactiver le centre VHU'
          : 'Réactiver le centre VHU'}
      </AntdMenu.Item>
    </AntdMenu>
  );

  return (
    <>
      <AntdButton
        onClick={() => {
          setIsDetailsOpen(true);
        }}
      >
        Détails
      </AntdButton>
      <ModalDetails
        centreVHU={centreVHU}
        visible={isDetailsOpen}
        close={() => {
          setIsDetailsOpen(false);
        }}
      />
      <ModalUpdate
        refreshDashboard={refreshDashboard}
        centreVHU={centreVHU}
        visible={isUpdateOpen}
        close={() => {
          setIsUpdateOpen(false);
        }}
      />
      <AntdDropdown overlay={menu} className="menuActions">
        <AntdButton>
          Actions <DownOutlined />
        </AntdButton>
      </AntdDropdown>
      {isChangeValidityOpen &&
        (centreVHU.valid ? (
          <ModalDesactivation
            idCorrelation={centreVHU.idCorrelation}
            titleModal="Désactiver le centre VHU"
            usesRequest={getUsesRequest}
            submitDeprecate={submitDeprecateReferentiel}
            componentUses={undefined}
            visible={isChangeValidityOpen}
            close={closeUpdateValidity}
            callAfterSubmit={refreshDashboard}
          />
        ) : (
          <ModalReactivation
            idCorrelation={centreVHU.idCorrelation}
            titleModal="Réactiver le centre VHU"
            visible={isChangeValidityOpen}
            close={closeUpdateValidity}
            callAfterSubmit={refreshDashboard}
            conditionRequest={conditionsReactivateReferentiel}
            componentConditions={ConditionReactivateCentreVHU}
            conditionUnlock={conditionUnlock}
            reactivateRequest={submitReactivateReferentiel}
          />
        ))}
    </>
  );
}

export default CellDetailsAndActions;
